import React, { useEffect, useState } from "react";
import { IoDiamondOutline } from "react-icons/io5";
import { PiLightbulbFilamentLight } from "react-icons/pi";
import { TbTargetArrow } from "react-icons/tb";
import "./aboutUs.scss";
interface AboutUsProps {}
function AboutUs(props: AboutUsProps) {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="about-body">
      <div className="about-img">
        <p>
          Рестарон паб лоунже нийтийн хоолны хэрэгцээт бүхий л барааг нэг дороос
        </p>
      </div>
      <div className="about-stats">
        <div className="about-stat">
          <h1>+8</h1>
          <p>Салбарын туршлага</p>
        </div>
        <div className="about-stat">
          <h1>+100</h1>
          <p>Хамтрагч байгууллага</p>
        </div>
        <div className="about-stat">
          <h1>+50</h1>
          <p>Хамтрагч брэндүүд</p>
        </div>
        <div className="about-stat">
          <h1>+500</h1>
          <p>Бараа, бүтээгдэхүүн</p>
        </div>
      </div>
      <div className="about-info">
        <div className="about-main">
          <div className="about-img2">
            <img src="logo.png" />
          </div>
          <div className="about-text">
            <h1>Бидний тухай:</h1>
            <p>
              Бид 2018 оноос мэргэжлийн тогооч болон хоол үйлдвэрлэлийн
              байгууллагуудад дэлхийн стандартад нийцсэн хүнсний түүхий эд,
              соус, амтлагч, хадгалах бүтээгдэхүүнийг түргэн шуурхай ,
              баталгаатай хүргэж өгч үйлчилж байна.
            </p>
            <p>
              Харилцагчдаа хурдан, найдвартай үйлчилгээ үзүүлэхийг зорьдог
              бөгөөд үйлчилгээний чанар, хүртээмжээ улам сайжруулсаар ирсэн.
            </p>
            <p>
              Рестарон паб лоунже нийтийн хоолны хэрэгцээт бүхий л барааг нэг
              дороос худалдан аваарай.
            </p>
          </div>
        </div>
        <div className="about-main2">
          <div className="about-card">
            <div className="about-red">
              <TbTargetArrow size={30} color="white" />
            </div>
            <div className="about-text">
              <h1>ЗОРИЛГО</h1>
              <p>
                <span>Харилцагчаа</span> дээдэлсэн, <span>чанарыг</span>
                эрхэмлэсэн, олон улсын <span>стандартыг</span> хангасан
                бүтээгдэхүүний үйлдвэрлэл, үйлчилгээ үзүүлэх
              </p>
            </div>
          </div>
          <div className="about-card">
            <div className="about-red">
              <PiLightbulbFilamentLight size={30} color="white" />
            </div>
            <div className="about-text">
              <h1>Алсын хараа</h1>
              <p>
                Үйлчлүүлэгчдийнхээ <span>бүтээмжийг</span> нэмэгдүүлэхийн тулд
                үргэлж <span>шинийг</span> эрэлхийлэх
              </p>
            </div>
          </div>
          <div className="about-card">
            <div className="about-red">
              <IoDiamondOutline size={30} color="white" />
            </div>
            <div className="about-text">
              <h1>ҮНЭТ ЗҮЙЛ</h1>
              <p>
                Аливаад <span>зөв</span> байх Ажиллагсадтайгаа
                <span>хамт хөгжин, үр дүнтэй</span> ажиллахын тулд{" "}
                <span>багийн ажиллагааг </span> эрхэмлэх
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AboutUs;
